import {
    CREATE_ORDER,
    GET_ORDER_DETAILS_BY_USERNAME,
    GET_ORDER_DETAILS_BY_ORDERID,
    GET_PAYMENT_METHOD,
    PAYMENT_BY_MOMO,
    PAYMENT_BY_ZALO_PAY,
} from "../actions/types";
    
export default function (state = {}, action) {
    switch (action.type) {
        case CREATE_ORDER:
            return { ...state, success: action.payload };
        case GET_ORDER_DETAILS_BY_USERNAME:
            return { ...state, orderDetails: action.payload };
        case GET_ORDER_DETAILS_BY_ORDERID:
            return { ...state, orderDetailsByOrderId: action.payload };
        case GET_PAYMENT_METHOD:
            return { ...state, paymentMethod: action.payload };
        case PAYMENT_BY_MOMO:
            return { ...state, paymentResponse: action.payload };
        case PAYMENT_BY_ZALO_PAY:
            return { ...state, paymentResponse: action.payload };
        default:
            return state;
    }
}
    